import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import appReducer from '../appSlice';
import homeReducer from '../containers/HomePage/slice';
import signupReducer from '../containers/SignupPage/slice';
import guestReducer from '../guestSlice';
import loginReducer from '../containers/LoginPage/slice';
import { init } from '../utils/webview/messages';

export const store = configureStore({
    reducer: {
        app: appReducer,
        home: homeReducer,
        signup: signupReducer,
        guest: guestReducer,
        login: loginReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;

init();

// Re-request native secure storage after long background so Redux can rehydrate
// if the JS heap was kept but tokens/session state went stale.
if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            init();
        }
    });
}
